// The error answers every offline handler shares (ADR 066 — Offline Mode § 3): a record the device
// does not hold, and a request with no signed-in scope on the device. One copy, so the screens'
// reads and the writes answer alike.

/** The answer for a record the device does not hold. */
export const NOT_FOUND = { kind: 'error', status: 404, error: 'Not found' } as const;

/** The answer for a request with no signed-in scope on the device. */
export const SIGNED_OUT = { kind: 'error', status: 401, error: 'Unauthorized' } as const;
